import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PersonalDataProtectionAPI from "../../api/PersonalDataProtectionAPI";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { Tooltip } from "flowbite-react";
import { toImagePath, toPascalCase } from "../../utils/globalFunctions";

function PersonalDataProtection() {
    const { i18n } = useTranslation();
    const [document, setDocument] = useState([]);
    const [openIndices, setOpenIndices] = useState([]);
    const [procurement, setProcurement] = useState([]);

    const fetchProcurement = async () => {
        try {
            const response = await (i18n.language === 'en' ? PersonalDataProtectionAPI.getDetailPersonalDataProtectionEn() : PersonalDataProtectionAPI.getDetailPersonalDataProtection());
            const data = response.data;
            setProcurement(data.document);
            setDocument(response.data);
        } catch (error) {
            console.error("ContactAPI.getDetailPersonalDataProtection", error);
        }
    };

    const toggleAccordion = (index) => {
        setOpenIndices((prevOpenIndices) =>
            prevOpenIndices.includes(index)
                ? prevOpenIndices.filter((i) => i !== index)
                : [...prevOpenIndices, index]
        );
    };

    useEffect(() => {
        fetchProcurement();
    }, [i18n.language]);
    

    return (
        <>
            <section className="banner bg-news-intro">
                <img
                    className="banner-image w-full"
                    src={"/images/contracts_bg/banner_faq.jpeg"}
                    alt="Hero Banner"
                />
                <div className="headline text-center">
                    <h1 className="headline-title text-3xl md:text-6xl font-bold text-white">
                        {document.title}
                    </h1>
                </div>
            </section>
            <section className="content p-4 md:p-8 bg-gray-50">
                <div className="content-container box-news-container">
                    <div className="content-header w-full">
                        <div className="col-span-2 bg-white p-6 rounded-l-lg">
                            {procurement &&
                                procurement.map((item, index) => (
                                    // <Tooltip content={item.title}>
                                    <div key={index} className="relative">
                                        <img
                                            src={toImagePath(item.figure.path)}
                                            alt={item.title}
                                            className="w-full h-auto rounded-t-lg"
                                        />
                                        <div className="w-full bg-[#E9EAF8] flex flex-col md:flex-row items-center justify-between p-5 font-medium rtl:text-right text-black rounded-b-md">
                                            <h5 className="w-full md:w-auto text-left font-bold mb-2 md:mb-0">
                                                {item.title}
                                            </h5>
                                            <a
                                                href={item.documentlink}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="bg-red-600 text-white text-center font-bold py-2 px-4 rounded-full"
                                                onClick={() => window.open(item.documentlink, "_blank")}
                                            >
                                                ดูเพิ่มเติม
                                            </a>
                                        </div>
                                    </div>
                                    // </Tooltip>
                                ))}


                            {Array.isArray(document.knowledge) &&
                                document.knowledge.map((item, index) => (
                                    <div key={index}>
                                        <button
                                            type="button"
                                            className="mt-5 flex items-center justify-between w-full p-5 font-medium rtl:text-right text-black border border-[#d6d7e1] focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-200 dark:border-grey-700 dark:text-black hover:bg-blue-100 dark:hover:bg-[#E9EAF8] gap-3 rounded-md"
                                            onClick={() => toggleAccordion(index)}
                                            aria-expanded={openIndices.includes(index)}
                                            aria-controls={`accordion-arrow-icon-body-${index}`}
                                        >
                                            <h5 className="text-left">{item.topic}</h5>
                                            <span className="text-xl rtl:text-left text-blue-900">
                                                {openIndices.includes(index) ? (
                                                    <FiMinusCircle />
                                                ) : (
                                                    <FiPlusCircle />
                                                )}
                                            </span>
                                        </button>
                                        <div
                                            id={`accordion-arrow-icon-body-${index}`}
                                            className={`${openIndices.includes(index) ? "block" : "hidden"
                                                } mt-5 p-5 border border-[#d6d7e1] dark:border-grey-700 bg-[#e9eaf7] rounded-md`}
                                        >
                                            <Tooltip content={item.topic}>
                                            <div className="relative">
                                                <img
                                                    src={item.figure?.path ? `${toImagePath(item.figure.path)}` : "https://dummyimage.com/270x150"}
                                                    alt="CISA Cyber Hygiene"
                                                    className="w-screen h-auto rounded-lg mb-4"
                                                />
                                            </div>
                                            </Tooltip>
                                            <p
                                                className="mb-2 text-blue-900 dark:text-blue-900"
                                                dangerouslySetInnerHTML={{ __html: item.detail }}
                                            ></p>
                                            <div className="flex justify-center">
                                                <a href={item.actionlink} className="bg-red-600 text-white text-center font-bold py-2 px-4 rounded-full w-full md:w-1/3 lg:w-1/4"  target="_blank"  rel="noopener noreferrer">
                                                    {item.actiontext}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="mt-5" dangerouslySetInnerHTML={{__html: document?.memo}}></div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PersonalDataProtection;
